<template>

<ui-button-options v-on:click.native.stop="viewItem()" :title="item.name">
      <div slot="left">
       
        <ui-icon color="#B4B4B4" :backgroundColor="getIconColor()" class="email-icon" :icon="getIcon()"></ui-icon>
      </div>
     
       <!--
      <div slot="options" v-if="computeUserAccess">
        <ui-option title="language.edit" v-on:click.native.stop.prevent="editItem()" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
        <ui-option title="language.delete" v-on:click.native.stop.prevent="deleteItem()" backgroundColor="#F46767" color="#FFFFFF" icon="times"/>
      </div>
      -->
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
//import UiOption from '../UiOption.vue';
//import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import UiIcon from '../UiIcon.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL';

export default {
  name: 'button-talk',
  props:{
    item:{default:{}}
  },
  data:function(){
    return {
    }
  },
  computed:{
    ...mapState([
       'appSettings'
      ]),
  },
  methods:{
    viewItem(){
      
      this.$router.push('/group/'+this.item.group_id+'/talks/'+this.item.talk_id);
      //this.$router.push('/group/'+this.item.group_id+'/talks/');
      
    },
    getIcon(){

        if (this.appSettings.user_level==USER_LEVEL.PARENT){
          var allPlanned = this.checkAllChildrenPlanned()
          return allPlanned ? 'check' : 'exclamation';
        }
        return 'comment'

    },
     getIconColor(){
       /*
      if (this.appSettings.user_level==USER_LEVEL.PARENT){
        var allPlanned = this.checkAllChildrenPlanned()
        return allPlanned ? '#8cc63e' : '#f46767';
      }
      */
      return 'transparent';
    },
     checkAllChildrenPlanned(){
      
      var allPlanned = true;
      
      this.item.children.forEach((child)=>{
        if(!child.time){
          allPlanned=false;
        }
      })

      return allPlanned;
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    //UiOption,
    UiIcon
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
.email-icon{
  font-size:1.5em;
}
</style>
